export const STAT_CARD_FRESHNESS_PERIOD_MULTIPLIER = 2;

export interface ScoutDashboardFreshPoint {
  timestamp: Date | string;
  value?: number | null;
}

export interface ScoutDashboardFreshSeries {
  points: ScoutDashboardFreshPoint[];
}

export interface ScoutDashboardFreshWidget {
  series: ScoutDashboardFreshSeries[];
}

function getTimestampMs(timestamp: Date | string | undefined): number | null {
  if (!timestamp) {
    return null;
  }

  const value = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  return Number.isFinite(value) ? value : null;
}

export function getLatestFreshValue(
  widget: ScoutDashboardFreshWidget,
  periodSeconds: number
): number | null {
  const firstSeries = widget.series[0];
  if (!firstSeries || !Number.isInteger(periodSeconds) || periodSeconds <= 0) {
    return null;
  }

  const latestPoint = firstSeries.points.at(-1);
  const latestTimestampMs = getTimestampMs(latestPoint?.timestamp);
  if (latestTimestampMs === null) {
    return null;
  }

  const freshnessWindowMs = periodSeconds * 1000 * STAT_CARD_FRESHNESS_PERIOD_MULTIPLIER;
  for (let index = firstSeries.points.length - 1; index >= 0; index -= 1) {
    const point = firstSeries.points[index];
    if (typeof point?.value !== "number") {
      continue;
    }

    const pointTimestampMs = getTimestampMs(point.timestamp);
    if (pointTimestampMs !== null && latestTimestampMs - pointTimestampMs <= freshnessWindowMs) {
      return point.value;
    }
  }

  return null;
}
